import React, { useState, useEffect } from "react";
import InfoBox from "../../ui/InfoBox";

type WordmarkFormProps = {
  onCancel: () => void;
  onSave: (data: {
    word: string;
    category: string;
    constitutionFile: File | null;
  }) => void;
  initialData?: {
    word?: string;
    category: string;
    constitutionFile?: File | null;
  };
  disabled?: boolean;
};

export default function WordmarkForm({
  onCancel,
  onSave,
  initialData,
  disabled,
}: WordmarkFormProps) {
  const [word, setWord] = useState(initialData?.word || "");
  const [category, setCategory] = useState(
    initialData?.category || "individualMark",
  );

  // const [constitutionOption, setConstitutionOption] = useState("now")
  // const [constitutionFile, setConstitutionFile] = useState<File | null>(initialData?.constitutionFile || null)
  // const [constitutionError, setConstitutionError] = useState("")

  useEffect(() => {
    if (initialData) {
      setWord(initialData.word || "");
      setCategory(initialData.category || "individualMark");
      // setConstitutionFile(initialData.constitutionFile || null)
    }
  }, [initialData]);

  /*
  const handleConstitutionSelect = (file: File) => {
    if (file.size > 2 * 1024 * 1024) {
      setConstitutionError("The file must not exceed 2 MB.")
      return
    }
    setConstitutionError("")
    setConstitutionFile(file)
  }
  */

  const handleSave = () => {
    onSave({
      word,
      category,
      constitutionFile: null,
    });
  };

  return (
    <div className="border rounded-md p-4 bg-white mt-6">
      <h3 className="text-lg font-semibold mb-3">Word Mark</h3>

      <InfoBox title="Hinweis">
        A word mark consists exclusively of words, letters, or numbers that can
        be represented in standard typed characters.
        <br />
        <span className="text-blue-700">Example:</span> PHILIPS, adidas,
        H&amp;M, A3, Vivid MEBFΛΛ.
      </InfoBox>

      <label className="block text-sm font-medium mb-1">
        Enter your trademark *
      </label>
      <input
        type="text"
        placeholder="Example: PHILIPS"
        value={word}
        onChange={(e) => setWord(e.target.value)}
        disabled={disabled}
        className={`w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:ring-1 focus:ring-orange-400 ${
          disabled ? "bg-gray-100 cursor-not-allowed" : ""
        }`}
      />

      <label className="block text-sm font-medium mb-2">
        Trademark category *
      </label>

      {
        <InfoBox title="Mark category">
          <strong>Individual mark:</strong> Can be owned by a natural or legal
          person. <br />
          {/* <strong>Union collective mark:</strong> Owned by an association, usable by its members. <br /> */}
          {/* <strong>Union certification mark:</strong> Owned by a certification body, usable by anyone meeting the criteria. */}
        </InfoBox>
      }

      <div className="flex gap-4 text-sm mb-4">
        {[
          ["individualMark", "Individual Mark"],
          // ["unionCollectiveMark", "Union Collective Mark"],
          // ["unionCertificationMark", "Union Certification Mark"],
        ].map(([val, label]) => (
          <label key={val} className="flex items-center gap-1">
            <input
              type="radio"
              name="category"
              value={val}
              checked={category === val}
              onChange={(e) => setCategory(e.target.value)}
              disabled={disabled}
            />
            {label}
          </label>
        ))}
      </div>

      {/*
      {(category === "unionCollectiveMark" || category === "unionCertificationMark") && (
        <>
          <InfoBox title="Please note">
            The fee for a Union collective mark or Union certification mark is higher.
            The constitution must be submitted within two months after the application.
          </InfoBox>

          <div className="border-t pt-4 mt-4">
            <label className="block text-sm font-medium mb-2">Constitution file</label>
            <div className="flex gap-4 text-sm mb-4">
              {[
                ["later", "Send later"],
                ["now", "Attach now"],
              ].map(([val, label]) => (
                <label key={val} className="flex items-center gap-1">
                  <input
                    type="radio"
                    name="constitution"
                    value={val}
                    checked={constitutionOption === val}
                    onChange={(e) => setConstitutionOption(e.target.value)}
                    disabled={disabled}
                  />
                  {label}
                </label>
              ))}
            </div>

            {constitutionOption === "now" && (
              <FileUploadBox
                uploadedFile={constitutionFile}
                error={constitutionError}
                onFileSelect={handleConstitutionSelect}
                accept="application/pdf,image/jpeg"
                preview={false}
                disabled={disabled}
              />
            )}
          </div>
        </>
      )}
      */}

      <div className="flex justify-end gap-4 mt-6">
        <button
          onClick={onCancel}
          className={`text-sm text-gray-600 hover:text-gray-800 ${
            disabled ? "cursor-not-allowed opacity-50" : ""
          }`}
          disabled={disabled}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className={`text-sm px-4 py-2 rounded-lg font-medium text-white transition ${
            disabled || word.trim() === ""
              ? "bg-gray-300 text-white cursor-not-allowed"
              : "bg-dantzOrange hover:brightness-110 active:scale-[0.98]"
          }`}
          disabled={disabled || word.trim() === ""}
        >
          Save
        </button>
      </div>
    </div>
  );
}
